import { render, staticRenderFns } from "./ImportForms.vue?vue&type=template&id=23c8685a&"
import script from "./ImportForms.vue?vue&type=script&lang=js&"
export * from "./ImportForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports